import Image from 'next/image';

import '../../generalStyles.css';

import { useRouter } from 'next/navigation';

import { isMobile } from 'react-device-detect';

import { useAuthStore } from '@/stores/userStore';

import { userUIStore } from '@/stores/userUIStore';

import { useAuth } from '@/core/auth/client/AuthProvider';

import LoginModal from '@/components/modals/LoginModal';

const DepositLanding = () => {
  const { session } = useAuth();
  const router = useRouter();
  const { account } = useAuthStore();
  const {
    toggleLoginModal,
    toggleDepositModal,
    isLoginModalOpen,
  } = userUIStore();

  const handleLoginModal = () => {
    if (session?.user?.id) {
      if (account?.contingencies?.deposits) {
        router.push('/?cont=4');
      } else if (isMobile) {
        router.push('/deposit');
      } else {
        toggleDepositModal();
      }
    } else {
      toggleLoginModal();
    }
  };

  return (
    <main
      className="flex flex-col items-center justify-between min-h-screen relative"
      style={{
        backgroundImage: "url('/img/v2/landings/deposit/bg-depositLanding.webp')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Image
        src="/img/v2/landings/deposit/HeaderLanding.webp"
        alt="cabecera Landing"
        width={230}
        height={230}
        priority
        className="mt-6"
      />
      <button type="button" className="btnSubmit z-50 my-5" onClick={handleLoginModal}> ¡Deposita ahora!</button>
      {isLoginModalOpen && <LoginModal />}
      <Image
        src="/img/v2/landings/deposit/logos.webp"
        alt="logos Landing"
        width={270}
        height={250}
        priority
        className="z-30"
      />
      <Image
        src="/img/v2/landings/deposit/Porky2.webp"
        alt="Footer Landing"
        width={1200}
        height={1200}
        priority
        className="w-full"
      />
    </main>
  );
};

export default DepositLanding;
